import SvgIcon from '@mui/material/SvgIcon';

export const MegatronIcon = () => (
  <SvgIcon
    width="58"
    height="39"
    viewBox="0 0 58 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M57.3296 0H21.3296V36H57.3296V0Z" fill="#1D0638" />
    <path
      d="M18.6595 4.64425L16.6603 34.3521L45.5549 36.2966L47.5542 6.58875L18.6595 4.64425Z"
      fill="#1D4050"
      stroke="#1EEF97"
      strokeWidth="0.0625"
      strokeMiterlimit="10"
    />
    <path
      d="M15.5382 10.6115L11.5398 33.0811L33.394 36.9699L37.3924 14.5004L15.5382 10.6115Z"
      fill="#1E7B68"
      stroke="#1EEF97"
      strokeWidth="0.125"
      strokeMiterlimit="10"
    />
    <path
      d="M12.4149 16.5787L6.41797 31.8107L21.2336 37.6437L27.2305 22.4117L12.4149 16.5787Z"
      fill="#1EB57F"
      stroke="#1EEF97"
      strokeWidth="0.1875"
      strokeMiterlimit="10"
    />
    <path
      d="M16.9099 30.3761L8.95496 22.4211L1 30.3761L8.95496 38.331L16.9099 30.3761Z"
      fill="#1EEF97"
      stroke="#1EEF97"
      strokeWidth="0.25"
      strokeMiterlimit="10"
    />
  </SvgIcon>
);
